/* eslint-disable camelcase */
import Vuetify from '../../plugins/vuetify'
import { CriticalDatasetLabels } from '../../enum'

const _t = (text) => Vuetify.framework.lang.t(text)

export class DetectorBeltEntry {
  constructor ({ belt_fasten = true, belt_fasten_behind_back = false } = {}) {
    this.beltFasten = belt_fasten // boolean
    this.beltFastenBehindBack = belt_fasten_behind_back // boolean
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      belt_fasten: this.beltFasten,
      belt_fasten_behind_back: this.beltFastenBehindBack
    }
  }

  get textRepresentation () {
    const result = []

    if (this.beltFasten) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.beltFastenDataset`))
    }

    if (this.beltFastenBehindBack) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.beltFastenBehindBackDataset`))
    }

    return result.map(item => ({
      item,
      color: 'black',
      type: CriticalDatasetLabels.BELT_DETECTOR
    }))
  }
}
